import _extends from '@babel/runtime/helpers/esm/extends';
import 'core-js/modules/es6.array.map.js';
import React__default from 'react';
import { TooltipV2 } from '../../tooltip-v2/tooltip-v2.js';
import { dropdownMenuItemToComponentMap } from './dropdown-menu-item-component-map.js';

var createDropdownMenuItems = function createDropdownMenuItems(items) {
  return items.map(function (item) {
    var Component = dropdownMenuItemToComponentMap(createDropdownMenuItems)[item.type];

    if (Component) {
      if (item.tooltipProps) {
        return /*#__PURE__*/React__default.createElement(TooltipV2, _extends({
          key: item.key
        }, item.tooltipProps), /*#__PURE__*/React__default.createElement(Component, item));
      }

      return /*#__PURE__*/React__default.createElement(Component, item);
    }

    return undefined;
  });
};

export { createDropdownMenuItems };
//# sourceMappingURL=dropdown-menu-create-items.js.map
